import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Layout  from '../../../Layout/Layout'; 

const TaskDelegation =() =>{
  localStorage.setItem('menu','Delegation');
  localStorage.setItem('submenu','Task Delegation');

  return(
    <main className="dashboard main" id="main"> 
      <Layout/>
        <Row className="justify-center subContent">
          <Col xs={12} md={12}  className="rightSide">

            <div className="rightSideInner timesheet">
              <h2 className='mainTitle'>Task Delegation</h2>
              <p className='subText'>Task Delegation Main title</p>
              <hr/>

              {/* Code Start Here */}
              <h1>Test coding Task Delegation</h1>

            </div>   
          </Col>
        </Row>
    </main>
  )
}

export default TaskDelegation;